import Vue from "vue";

import WishList from "./WishList.vue";

export function load() {
    const selector = "wish-list";

  // Is the custom Vue root element in the DOM?
  if (!document.querySelector(selector)) {
    return;
  }

  // Create a new Vue app with the imported Home component
  new Vue({
    render: createElement =>
      createElement(WishList, {
        props: {
          ...window[selector],
        },
      }),
  }).$mount(selector);
}